import React from 'react';
import SidebarContainer from './Sidebar.styles';

const Sidebar = (props) => {
  const { children } = props;
  return <SidebarContainer>{children}</SidebarContainer>;
};

export default Sidebar;
